import { root } from './process';

export const process = {
  ...root,
};
